import { render, staticRenderFns } from "./CustomerInfoModal.vue?vue&type=template&id=c2404164&scoped=true&"
import script from "./CustomerInfoModal.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInfoModal.vue?vue&type=style&index=0&id=c2404164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2404164",
  null
  
)

export default component.exports